import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import authService from '../../utils/authService';
import '../../styles/AdminBlog.css';

const AdminBlog = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const token = authService.getToken();
      const response = await axios.get('/api/admin/blog', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) setPosts(response.data.posts);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this post?')) return;
    try {
      const token = authService.getToken();
      await axios.delete(`/api/admin/blog/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchPosts();
    } catch (error) {
      alert('Failed to delete post');
    }
  };

  const handlePublish = async (id) => {
    try {
      const token = authService.getToken();
      await axios.post(`/api/admin/blog/${id}/publish`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchPosts();
    } catch (error) {
      alert('Failed to publish post');
    }
  };

  const filteredPosts = posts.filter(p => 
    filter === 'all' || p.status === filter
  );

  if (loading) return <div className="admin-loading">Loading...</div>;

  return (
    <div className="admin-blog">
      <div className="admin-header">
        <div>
          <h1>Blog Posts</h1>
          <p>Manage your blog content</p>
        </div>
        <Link to="/admin/blog/new" className="btn btn-primary">+ New Post</Link>
      </div>

      <div className="blog-filters">
        <button className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>
          All ({posts.length})
        </button>
        <button className={filter === 'published' ? 'active' : ''} onClick={() => setFilter('published')}>
          Published ({posts.filter(p => p.status === 'published').length})
        </button>
        <button className={filter === 'draft' ? 'active' : ''} onClick={() => setFilter('draft')}>
          Drafts ({posts.filter(p => p.status === 'draft').length})
        </button>
      </div>

      <div className="blog-list">
        {filteredPosts.length === 0 ? (
          <div className="empty-state">
            <p>No posts yet. Create your first one!</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Status</th>
                <th>Views</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPosts.map(post => (
                <tr key={post._id}>
                  <td>
                    <div className="post-title">
                      {post.featured && <span className="badge-featured">⭐</span>}
                      {post.title.pt}
                    </div>
                  </td>
                  <td><span className="badge-category">{post.category}</span></td>
                  <td>
                    <span className={`badge-status badge-${post.status}`}>
                      {post.status}
                    </span>
                  </td>
                  <td>{post.views}</td>
                  <td>{new Date(post.createdAt).toLocaleDateString()}</td>
                  <td className="actions">
                    <button onClick={() => navigate(`/admin/blog/edit/${post._id}`)} className="btn-icon" title="Edit">✏️</button>
                    {post.status === 'draft' && (
                      <button onClick={() => handlePublish(post._id)} className="btn-icon" title="Publish">🚀</button>
                    )}
                    <button onClick={() => handleDelete(post._id)} className="btn-icon btn-danger" title="Delete">🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminBlog;
